import { combineReducers } from "redux";
import { blogListRedux } from "./blog-list/reducers";
import { blogDetailsRedux } from "./blog-details/reducers";
import { blogHeaderRedux } from "./blog-header/reducers";

const rootReducer = combineReducers({
  blogHeader: blogHeaderRedux.reducer,
  blogList: blogListRedux.reducer,
  blogDetails: blogDetailsRedux.reducer,
});

export default rootReducer;
